import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateFormatPipe',
    standalone: false
})
export class dateFormatPipe implements PipeTransform {
    transform(value: string, format: string) {
       var datePipe = new DatePipe("pt-BR");
        value = datePipe.transform(value, format);
        return value;
    }
}